import { htmlSafe } from '@ember/template';
import Component from '@glimmer/component';

import type { BadgeType } from '../../../types/components/prism/badge.ts';
import type {
  DisabledArgs,
  IconArgs,
} from '../../../types/components/prism/combo-select-input.ts';
import PrismBadge from '../badge.gts';
import PrismCheckbox from '../checkbox.gts';
import PrismIcon from '../icon.gts';
import PrismTooltip from '../tooltip.gts';

interface PrismComboSelectInputMultipleSelectionOptionSignature {
  Args: DisabledArgs &
    IconArgs & {
      badge?: string;
      badgeType?: BadgeType;
      label: string;
      selected: boolean;
      unsafe_bulletColor?: string;
      unsafe_subLabel?: string;
    };
}

export default class PrismComboSelectInputMultipleSelectionOption extends Component<PrismComboSelectInputMultipleSelectionOptionSignature> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get badgeType() {
    if (!this.args.badgeType) {
      return this.args.disabled ? 'neutral' : 'info';
    }
    return this.args.badgeType;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get disabledMessage() {
    return this.args.disabled ? this.args.disabledMessage : undefined;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get iconColor() {
    return this.args.disabled ? 'disabled' : undefined;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get unsafe_bulletStyle() {
    return htmlSafe(`background-color:${this.args.unsafe_bulletColor}`);
  }

  <template>
    <div class="prism-combo-select-input__multiple-option-row">
      <div class="multiple-select-option">
        <div class="multiple-select-option__checkbox-container">
          <PrismCheckbox
            @checked={{@selected}}
            @disabled={{@disabled}}
            tabindex="-1"
          />
        </div>
        {{#if @icon}}
          <PrismIcon @color={{this.iconColor}} @name={{@icon}} @size="small" />
        {{/if}}
        {{#if @unsafe_bulletColor}}
          <span
            class="multiple-select-option__unsafe-bullet"
            style={{this.unsafe_bulletStyle}}
          />
        {{/if}}
        {{#if @unsafe_subLabel}}
          <div class="multiple-select-option__unsafe-sub-label-container">
            <p class="text-300--regular multiple-select-option__label truncate">
              {{@label}}
            </p>
            <p
              class="text-200--regular multiple-select-option__unsafe-sub-label truncate"
            >
              {{@unsafe_subLabel}}
            </p>
          </div>
        {{else}}
          <p
            class="multiple-select-option__label text-300--regular truncate"
          >{{@label}}</p>
        {{/if}}
      </div>
      {{#if @badge}}
        <PrismBadge @type={{this.badgeType}}>{{@badge}}</PrismBadge>
      {{/if}}
    </div>
    {{#if this.disabledMessage}}
      <PrismTooltip @side="right" @text={{this.disabledMessage}} />
    {{/if}}
  </template>
}
